import { ColumnStartOrder, ColumnName, ColumnNoc,  ColumnExpander, ColumnQualification } from "components/common/TableColumns"
import { ColumnApparatus, ColumnResultApparatus, ColumnResult, ColumnRankAllArround} from "./TableColumns"

export function rotationColumns() {
    return (
        [
            ColumnStartOrder({}),
            ColumnNoc({}),
            ColumnName({}),
            ColumnApparatus({}),
            ColumnResult({label: 'HeaderScore'}),
            ColumnExpander({})
        ]
    )
}

////'HOOP' 'BALL', 'CLUBS', 'RIBBON'
export function resultsColumns(rotation, status) {
    return (
        [
            ColumnRankAllArround({rotation: rotation, status: status}),
            ColumnStartOrder({}),
            ColumnNoc({}),
            ColumnName({}),
            ColumnResultApparatus({apparatus:'HOOP'}),
            ColumnResultApparatus({apparatus:'BALL'}),
            ColumnResultApparatus({apparatus:'CLUBS'}),
            ColumnResultApparatus({apparatus:'RIBBON'}),
            ColumnResultApparatus({apparatus:'5_HOOPS', headerClassName: 'text-end w-15'}),
            ColumnResultApparatus({apparatus:'3_RIBBONS_2_BALLS', headerClassName: 'text-end w-15'}),           
            ColumnResult({label: 'HeaderTotal'}),
            ColumnQualification({}),
            ColumnExpander({})
        ]
    )
}
